import { useNotificationStore, INotificationOptions } from '@/stores/notifications';


export function useNotification() {
    const notificationStore = useNotificationStore();

    const showNotification = (options: INotificationOptions) => {
        notificationStore.notify({
            message: options?.message || 'error',
            type: options.type || 'info',
            timeout: options?.timeout || 5000,
        });
    };

    return { showNotification };
}